import script from "./SignaturePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignaturePreview.vue?vue&type=script&setup=true&lang=ts"

import "./SignaturePreview.vue?vue&type=style&index=0&id=a6775708&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6775708"]])

export default __exports__